import { render, staticRenderFns } from "./menu-principal.vue?vue&type=template&id=19fbc299&scoped=true&"
import script from "./menu-principal.vue?vue&type=script&lang=ts&"
export * from "./menu-principal.vue?vue&type=script&lang=ts&"
import style0 from "./menu-principal.vue?vue&type=style&index=0&id=19fbc299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbc299",
  null
  
)

export default component.exports